import { render, staticRenderFns } from "./TablePageTemplate.vue?vue&type=template&id=17719e68&scoped=true"
import script from "./TablePageTemplate.vue?vue&type=script&lang=js"
export * from "./TablePageTemplate.vue?vue&type=script&lang=js"
import style0 from "./TablePageTemplate.vue?vue&type=style&index=0&id=17719e68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17719e68",
  null
  
)

export default component.exports